import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=5850e732&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5850e732')) {
      api.createRecord('5850e732', component.options)
    } else {
      api.reload('5850e732', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=5850e732&", function () {
      api.rerender('5850e732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bDCRZHq716kA/JS/comp/ErrorMessage.vue"
export default component.exports